/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MissionControllerDtoMissionFreeInfoDetailRequest model module.
 * @module model/MissionControllerDtoMissionFreeInfoDetailRequest
 * @version 1.0
 */
class MissionControllerDtoMissionFreeInfoDetailRequest {
    /**
     * Constructs a new <code>MissionControllerDtoMissionFreeInfoDetailRequest</code>.
     * @alias module:model/MissionControllerDtoMissionFreeInfoDetailRequest
     */
    constructor() { 
        
        MissionControllerDtoMissionFreeInfoDetailRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MissionControllerDtoMissionFreeInfoDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MissionControllerDtoMissionFreeInfoDetailRequest} obj Optional instance to populate.
     * @return {module:model/MissionControllerDtoMissionFreeInfoDetailRequest} The populated <code>MissionControllerDtoMissionFreeInfoDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MissionControllerDtoMissionFreeInfoDetailRequest();

            if (data.hasOwnProperty('missionNo')) {
                obj['missionNo'] = ApiClient.convertToType(data['missionNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MissionControllerDtoMissionFreeInfoDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MissionControllerDtoMissionFreeInfoDetailRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} missionNo
 */
MissionControllerDtoMissionFreeInfoDetailRequest.prototype['missionNo'] = undefined;






export default MissionControllerDtoMissionFreeInfoDetailRequest;

